import * as yup from "yup"
import { Tag } from "../../types"

export function initialValuesTag(tag?: Tag | undefined) {
  if (tag) {
    return tag
  }
  return {
    nome: "",
    tipologia: "",
  }
}

export function validationSchemaTag() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
    tipologia: yup.string().required("Campo obbligatorio"),
  })
}
